document.addEventListener('click', async function (event) {
  const button = event.target.closest('.custom-card-add-to-cart');

  if (!button) return;

  event.preventDefault();

  const variantId = Number(button.dataset.variantId);
  const cartDrawer = document.querySelector('cart-drawer');

  if (!variantId || !cartDrawer) return;

  button.disabled = true;

  try {
    const formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', 1);

    formData.append(
      'sections',
      cartDrawer
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',')
    );

    formData.append('sections_url', window.location.pathname);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || 'No se pudo añadir el producto');
    }

    cartDrawer.renderContents(result);
  } catch (error) {
    console.error(error);
    alert(error.message);
  } finally {
    button.disabled = false;
  }
});